import classNames from 'classnames';
import {map, orderBy} from 'lodash';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import swal from 'sweetalert2';
import {
  fetchMatchIfNeeded,
  updateMark,
} from '../../../../actions/app/onSite/matches/read';
import lequipeBrand from '../../../../assets/img/brand/lequipe.svg';
import Loader from '../../../../components/Loader';
import selectEntities from '../../../../selectors/entities';
import {getChampionshipClubs} from '../../../Tools/Tds/Widgets/TdsList';
import './MatchRead.css';

class MatchRead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {LEQUIPERates: {}, focusedInputValue: '', clubs: undefined};
  }

  displayRequestMessage(info = this.props.widget.info) {
    if (info.error) {
      switch (info.error) {
        default:
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong with: "${info.lastAction}"<br/>` +
              `<pre><code>${JSON.stringify(info, undefined, 4)}</code></pre>`,
          });
      }
    }
  }

  updatePlayerMark(key, e) {
    if (e) e.preventDefault();
    const mark = this.state.LEQUIPERates[key];
    mark &&
      parseInt(mark, 10) !== parseInt(this.state.focusedInputValue, 10) &&
      this.props.dispatch(
        updateMark({
          playerId: key,
          matchId: this.props.entity.id,
          mark,
        }),
      );
  }

  componentDidMount() {
    this.props.dispatch(
      getChampionshipClubs({onSuccess: clubs => this.setState({clubs})}),
    );
    this.props.dispatch(
      fetchMatchIfNeeded({matchId: this.props.match.params.id}),
    );
  }

  componentWillReceiveProps(nextProps) {
    const {info} = this.props.page;
    const nextInfo = nextProps.page.info;

    if (info.success !== nextInfo.success || info.error !== nextInfo.error)
      this.displayRequestMessage(nextInfo);

    if (
      nextProps.entity !== this.props.entity &&
      nextProps.entity.home &&
      nextProps.entity.away
    ) {
      const {LEQUIPERates} = this.state;

      map(
        nextProps.entity.home.players,
        player => (LEQUIPERates[player.id] = player.equipeRating),
      );
      map(
        nextProps.entity.away.players,
        player => (LEQUIPERates[player.id] = player.equipeRating),
      );

      this.setState({LEQUIPERates});
    }
  }

  renderTeam(side, entity, winner) {
    const {LEQUIPERates} = this.state;
    const {info} = this.props.page;

    const renderGoals = player => {
      if (!player.stats) {
        return;
      }
      const render = [];
      for (let i = 0; i < player.stats.goals; i++) {
        render.push(<i key={i} className="fa fa-soccer-ball-o" />);
      }
      return render;
    };

    const positions = {
      1: 'Goalkeeper',
      2: 'Defender',
      3: 'Midfielder',
      4: 'Striker',
    };
    return (
      <div className="col-md-6">
        <div className={classNames('box', {'box-success': winner})}>
          <div>
            <div className="box-header">
              <h3 className="box-title" style={{width: '100%'}}>
                <i
                  className={classNames('fa', {
                    'fa-home': side === 'home',
                    'fa-plane': side === 'away',
                  })}
                />{' '}
                {(entity && entity.club) || side}
                <span
                  className={classNames('label pull-right label-default ', {
                    'label-success': winner,
                  })}>
                  {!entity ||
                  (entity && entity.score === undefined) ||
                  entity.score === null
                    ? 'to come'
                    : entity.score}
                </span>
              </h3>
            </div>
            <div className="box-body no-padding">
              {info.isFetching && <Loader />}
              {entity && (
                <table className="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th className="visible-md visible-lg">
                        {this.state.clubs && (
                          <img
                            src={
                              this.state.clubs[entity.clubId].defaultJerseyUrl
                            }
                            style={{width: 50, height: 50}}
                            alt=""
                          />
                        )}
                      </th>
                      <th>Name</th>
                      <th>Played</th>
                      <th>Position</th>
                      <th className="text-center">Rate</th>
                      <th className="text-right">
                        <img
                          src={lequipeBrand}
                          alt="Logo LEQUIPE"
                          height="20"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {entity.players ? (
                      map(
                        orderBy(
                          entity.players,
                          ['sub', 'mpgRating'],
                          ['asc', 'desc'],
                        ),
                        (player, key) => (
                          <tr key={key}>
                            <td className="visible-md visible-lg">
                              {player.id.replace(
                                'mpg_championship_player_',
                                '',
                              )}
                            </td>
                            <th
                              className={classNames('name', {
                                'text-green':
                                  player.stats && player.stats.goals > 0,
                              })}>
                              {player.lastName} {renderGoals(player)}
                            </th>
                            <td>
                              {player.sub ? (
                                <span className="label label-default">
                                  Sub.
                                </span>
                              ) : (
                                player.stats.minutes_played + ' min.'
                              )}
                            </td>
                            <td>{positions[player.realPosition]}</td>
                            <th
                              className={classNames('text-center', {
                                'text-red': player.mpgRating < 4,
                              })}>
                              {player.mpgRating}
                            </th>
                            <td style={{width: '80px'}}>
                              <div
                                style={{position: 'relative'}}
                                className={classNames('form-group', {
                                  'has-success':
                                    info.success &&
                                    info.lastAction ===
                                      'REQUEST_UPDATE_PLAYER_MATCH_MARK' &&
                                    info.lastPayload.playerId === player.id,
                                })}>
                                <input
                                  type="number"
                                  min={0}
                                  max={10}
                                  className="form-control text-center"
                                  value={LEQUIPERates[player.id]}
                                  onBlur={e =>
                                    this.updatePlayerMark(player.id, e)
                                  }
                                  onChange={e => {
                                    LEQUIPERates[player.id] = e.target.value;
                                    this.setState({LEQUIPERates});
                                  }}
                                  onFocus={e => {
                                    const focusedInputValue = e.target.value;
                                    this.setState({focusedInputValue});
                                  }}
                                />
                                <i
                                  className={classNames({
                                    'form-control-feedback fa fa-check':
                                      info.success &&
                                      info.lastAction ===
                                        'REQUEST_UPDATE_PLAYER_MATCH_MARK' &&
                                      info.lastPayload.playerId === player.id,
                                  })}
                                />
                              </div>
                            </td>
                          </tr>
                        ),
                      )
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center text-muted">
                          There is no player for that match
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {entity, match} = this.props;
    const {params} = match;

    return (
      <div id="match-read">
        <header className="content-header">
          <h1>
            Match {params.id} {entity && moment(entity.dateMatch).format('LL')}{' '}
            <small>Information</small>
          </h1>
          <ol className="breadcrumb">
            <li>
              <i className="fa fa-desktop" /> On Site
            </li>
            <li className="text-bold">
              <Link to="/matches">Matches</Link>
            </li>
            <li className="text-bold">
              <Link to="/matches/read/1">Match {params.id}</Link>
            </li>
          </ol>
        </header>
        <section className="content">
          <div className="row">
            {this.renderTeam(
              'home',
              entity.home,
              entity.home && entity.home.score > entity.away.score,
            )}
            {this.renderTeam(
              'away',
              entity.away,
              entity.away && entity.home.score < entity.away.score,
            )}
          </div>
        </section>
      </div>
    );
  }
}

export default connect(
  state => {
    const {matches} = state.entities;
    const page = state.app.onSite.matches.read;

    return {page, entity: selectEntities(matches, [page.id])[0] || {}};
  },
  dispatch => ({dispatch}),
)(MatchRead);



// WEBPACK FOOTER //
// ./src/pages/OnSite/Matches/Read/index.js